import { Pipe, PipeTransform } from '@angular/core';
import { GlobalService } from './global.service';
import { map, Observable, Subject, takeUntil } from 'rxjs';


export interface IFormatParams {
  mask: string;
  thousandSeparator: string;
  decimalMarker: string;
}

@Pipe({
  name: 'pricingFormatHelper'
})

export class PricingFormatHelperPipe implements PipeTransform {

  constructor (private _globalService$: GlobalService) {}
  private destroy$ = new Subject<void>();

  transform(): Observable<IFormatParams> {
    return this._globalService$.getUserCompanySettings().pipe(
      takeUntil(this.destroy$),
      map((companySettings) => {
        const pricing_format_example = companySettings?.pricing_format_example;

        const params: IFormatParams = {
          mask: 'separator.2',
          thousandSeparator: ',',
          decimalMarker: '.',
        };

        if (pricing_format_example === '1,000.50') {
          params.mask = 'separator.2';
          params.thousandSeparator = ',';
          params.decimalMarker = '.';
        } else if (pricing_format_example === '1 000,50') {
          params.mask = 'separator.2';
          params.thousandSeparator = ' ';
          params.decimalMarker = ',';
        } else if (pricing_format_example === '1.000,50') {
          params.mask = 'separator.2';
          params.thousandSeparator = '.';
          params.decimalMarker = ',';
        } else if (pricing_format_example === '1000.50') {
          params.mask = 'separator.2';
          params.thousandSeparator = '';
          params.decimalMarker = '.';
        } else if (pricing_format_example === '1000,50') {
          params.mask = 'separator.2';
          params.thousandSeparator = '';
          params.decimalMarker = ',';
        }

        console.log('Params:', params);
        return params;
      })
    );
  }

}
